export const MSCU = "MSCU";
export const MSNA = "MSNA";
export const TBPR = "TBPR";
export const APAC = "APAC";
export const JPN_KOR = "JPN-KOR";
export const OCEANIA = "OCEANIA";
export const EMEA = "EMEA";
export const AM = "AM";

export const FE_MSCU = "eclr";
export const FE_MSNA = "ufog";
export const FE_TBPR = "cmon";

// ─── Service 域名常量 ────────────────────────────────────────────────

// gs-robot.com 体系
export const SERVICE_MA  = 'service-ma.gs-robot.com';
export const SERVICE_EU  = 'service-eu.gs-robot.com';
export const SERVICE_UK  = 'service-uk.gs-robot.com';
export const SERVICE_AP  = 'service-ap.gs-robot.com';
export const SERVICE_US  = 'service-us.gs-robot.com';
export const SERVICE_NE  = 'service-ne.gs-robot.com';

// gausium-robot.com 体系
export const BOT_GAUSIUM_CN = 'bot.gausium-robot.com';
export const BOT_GAUSIUM_EU = 'bot.eu.gausium-robot.com';
export const BOT_GAUSIUM_US = 'bot.us.gausium-robot.com';

export const ESCALADE_GAUSIUM_EU = 'escalade.eu.gausium-robot.com';
export const ESCALADE_GAUSIUM_US = 'escalade.us.gausium-robot.com';

export const CCS_GAUSIUM_EU = 'ccs.eu.gausium-robot.com';
export const CCS_GAUSIUM_US = 'ccs.us.gausium-robot.com';
